module.exports = __webpack_public_path__ + "img/816.33775df7.png";